// ** Initial State
const initialState = {
  loading: true,
  item: [],
  questions: null,
  filterQuestions:null,
  currentPage:1
};

const samplesReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FILTER_QUESTIONS":
      return{
        ...state,
        filterQuestions: action.payload,
        loading: action.loading,
      }
    case "LOADING_DATA":
      return {
        ...state,
        loading: action.loading,
      };
    case "SET_QUESTIONS":
      return { ...state, questions: action.questions };
      case "PAGE_CHANGE":
        return { ...state, currentPage: action.payload.currentPage +1 }
    default:
      return state;
  }
};

export default samplesReducer;
